import axios from 'axios'
import { instanceApi } from '@/services/ProviderService'

export default {
    checkLogin(username, password){
        const http = axios.create({ baseURL: source.state.apiEndpoint });
        http.defaults.headers.common['Content-Type'] = 'application/json'
        return http.post(`/auth`, { "username": username, "password": password} );
    },
    isLogin(){
        let _token = localStorage.getItem("_token")
        let check = _token != undefined && _token != "" ? true : false
        return check
    },
    login(username, password){
        return instanceApi().post(`/auth/login`, { "username": username, "password": password} );
    }
}
